import { createTextColorPlugin } from './createTextColorPlugin.js';
import { createTextHighlightPlugin } from './createTextHighlightPlugin.js';
import { TEXT_COLOR_TYPE, TEXT_HIGHLIGHT_TYPE } from './types.js';
import { DEFAULTS } from './constants.js';
import { ModalsMap } from './modals.js';
import { tiptapExtensions } from './tiptap.js';
import { getTextColorTextButtons, getTextHighlightTextButtons } from './getTextButtons.js';
import 'wix-rich-content-plugin-commons';
import './toolbar/createToolbar.js';
import './toolbar/getTextColorButtonProps.js';
import 'react';
import 'wix-rich-content-editor-common';
import './toolbar/TextColorPanel.js';
import 'prop-types';
import './text-decorations-utils.js';
import './color-scheme-utils.js';
import 'wix-rich-content-common';
import 'lodash';
import './toolbar/TextColorIcon.js';
import './toolbar/TextHighlightIcon.js';
import './toolbar/TextColorButton.js';
import './toolbar/BaseTextColor.js';
import 'classnames';
import 'react-modal';
import './toolbar/TextHighlightButton.js';
import 'immutable';
import 'ricos-schema';
import 'ricos-schema/dist/statics/color.defaults.json';
import 'ricos-types';
import 'wix-rich-content-toolbars-v3/libs/resolvers-ids';
import './icons/TextColorIcon.js';
import './icons/TextHighlightIcon.js';
import './TextColorController.js';
import 'ricos-context';
import './TextColorPicker.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginTextColor = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.configTextColor.editor), config),
    type: TEXT_COLOR_TYPE,
    createPlugin: createTextColorPlugin,
    ModalsMap,
    tiptapExtensions,
    textButtons: getTextColorTextButtons()
  };
};
const pluginTextHighlight = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.configTextHighlight.editor), config),
    type: TEXT_HIGHLIGHT_TYPE,
    createPlugin: createTextHighlightPlugin,
    ModalsMap: {},
    textButtons: getTextHighlightTextButtons()
  };
};

export { pluginTextColor, pluginTextHighlight };
//# sourceMappingURL=editor.js.map
